import React, { createContext, useEffect, useState } from "react"
import { getCurrentPrice, getSecurityDeposit } from "app/React/Helpers/PriceHelper"
import { validateSteps } from "app/React/Helpers/StepHelper";
import { storageSet } from "app/React/Helpers/StorageHelper";
import StorageLoad from "app/React/Components/misc/StorageLoad";
import {
  accessoryIsArrayDiff,
  accessoryStorageGet,
  accessoryStorageSet
} from "app/React/Helpers/AccessoryStorageHelper";
import { containsProductThatDontFitModelByID } from "utils/containsProductThatDontFitModelByID";
import { accessoryProductFitsCarByID } from "utils/accessoryProductFitsCarByID";

const ConfiguratorContext = createContext({})

export default function ConfiguratorContainer(props) {
  const [_currentStep, _setCurrentStep] = useState(props.currentStep ?? null)
  const [accessoriesShop] = useState(props.accessories_shop ?? {})
  const [car, setCar] = useState(props.car ?? {})
  const [cartItems, setCartItems] = useState(accessoryStorageGet('cart-items') ?? [])
  const [checkedChargings, setCheckedChargings] = useState(props.checkedChargings ?? {})
  const [checkedEquipmentRequirements, setCheckedEquipmentRequirements] = useState(props.checked ?? {})
  const [colorImage, setColorImage] = useState(props.colorImage ?? null)
  const [colorName, setColorName] = useState(props.colorName ?? null)
  const [colorSettingId, setColorSettingId] = useState(props.color_setting_id ?? null)
  const [configurationLinkAvailable] = useState(props.configurationLinkAvailable ?? false)
  const [configuratorUrl] = useState(props.configurator_url ?? '')
  const [currentDealerColorTotalCount, setCurrentDealerColorTotalCount] = useState(props.currentDealerColorTotalCount ?? 1)
  const [currentEngineTransmission, setCurrentEngineTransmission] = useState(props.currentEngineTransmission ?? null)
  const [currentLeasingPriceRanges, setCurrentLeasingPriceRanges] = useState(props.currentLeasingPriceRanges ?? null)
  const [currentModelYear, setCurrentModelYear] = useState(props.currentModelYear ?? null)
  const [currentVariant, setCurrentVariant] = useState(props.currentVariant ?? null)
  const [dealerNumberOptions] = useState(props.dealerNumberOptions ?? [])
  const [dealerEmail] = useState(props.dealerEmail ?? null)
  const [dealerDebitorEmails] = useState(props.dealerDebitorEmails ?? [])
  const [dealerDebitorNumbers] = useState(props.dealerDebitorNumbers ?? [])
  const [dealerPbvSpecificDebitorNumbers] = useState(props.dealerPbvSpecificDebitorNumbers ?? [])
  const [disabledEquipmentRequirements, setDisabledEquipmentRequirements] = useState(props.disabled ?? {
    required: currentVariant?.steps['3']?.equipmentRequirements ?? {},
    excludes: {}
  })
  const [endpoints] = useState(props.endpoints ?? {})
  const [engineTransmissions] = useState(props.engineTransmissions ?? [])
  const [errors, setErrors] = useState(props.errors ?? {})
  const [hasConfiguration] = useState(props.hasConfiguration ?? false)
  const [homeUrl] = useState(props.home_url ?? '#')
  const [identifier] = useState(props.identifier ?? '')
  const [isAccessoryShop] = useState(props.isAccessoryShop ?? false)
  const [isAccessoryShopOpen, setIsAccessoryShopOpen] = useState(props.isAccessoryShopOpen ?? false)
  const [isDealerConfigurator] = useState(props.isDealerConfigurator ?? false)
  const [isMenuOpen, setIsMenuOpen] = useState(props.isMenuOpen ?? false)
  const [isStorageOrderHandled, setIsStorageOrderHandled] = useState(false)
  const [interiorImage, setInteriorImage] = useState(props.interiorImage ?? false)
  const [lang] = useState(props.lang ?? 'da-DK')
  const [locations] = useState(props.locations ?? {})
  const [logo] = useState(props.logo ?? {})
  const [modelYears] = useState(props.modelYears ?? [])
  const [mgConfiguratorStep] = useState(props.mg_configurator_step ?? {})
  const [openConfigurationLink, setOpenConfigurationLink] = useState(props.openConfigurationLink ?? false)
  const [showGoWish] = useState(props.showGoWish ?? false)
  const [order, setOrder] = useState(props.order ?? {})
  const [paymentCardsImage] = useState(props.payment_cards_image ?? {})
  const [paymentTypes] = useState(props.paymentTypes ?? {})
  const [restNonce] = useState(props.rest_nonce ?? '')
  const [showPlateFieldAccessoryIds] = useState(props.showPlateFieldAccessoryIds ?? [])
  const [strings] = useState(props.strings ?? {})
  const [useSelectForDealers] = useState(props.use_select_for_dealers ?? false)
  const [variants] = useState(props.variants ?? [])
  const [validSteps, setValidSteps] = useState(props.validSteps ?? [])
  const [vehicleType] = useState(props.vehicleType ?? '')
  const [zipCodes] = useState(props.zipCodes ?? {})
  const [hideSecurityDeposit] = useState(props.hideSecurityDeposit ?? false)
  const [orderType] = useState(props.orderType ?? null)
  const [showGlobalDownPaymentReservationText] = useState(props.show_global_down_payment_reservation_text ?? false)
  const [useStorage] = useState(props.use_storage ?? true)

  const isGlobalDownPaymentCash = Number(props.global_down_payment_cash) === props.global_down_payment_cash
  const isGlobalDownPaymentLeasing = Number(props.global_down_payment_leasing) === props.global_down_payment_leasing
  const globalDownPaymentCash = props.global_down_payment_cash
  const globalDownPaymentLeasing = props.global_down_payment_leasing


  const defaultValidateSteps = () =>
    setValidSteps(validateSteps(currentVariant.steps ?? {}, order, isDealerConfigurator, currentVariant))

  const setCurrentStep = (nextStep) => {
    if (!props.hasOwnProperty('useHistory') || props.useHistory) {
      const urlTemplate = window.location.protocol + '//' + window.location.host + '/' + mgConfiguratorStep.route
      const url = urlTemplate.replace('{identifier}', props.car_identifier).replace('{step}', nextStep)
      history.pushState(nextStep, null, url)
    }

    _setCurrentStep(nextStep)
  }

  const showModelYearOnVariants = () => {
    if (modelYears.length <= 1) {
      return false
    }

    if (isDealerConfigurator) {
      return props.hasOwnProperty('show_model_year_on_variants_dealer') ? props.show_model_year_on_variants_dealer : false
    }

    return props.hasOwnProperty('show_model_year_on_variants_customer') ? props.show_model_year_on_variants_customer : false
  }

  useEffect(() => {
    const storageCartItems = accessoryStorageGet('cart-items') ?? []

    if (! isAccessoryShop) {
      if (containsProductThatDontFitModelByID(storageCartItems, car.id) || containsProductThatDontFitModelByID(cartItems, car.id)) {
        const modalElement = window.jQuery('#cart-warning')
        modalElement.addClass('mtt-modal--show')
        document.querySelector('#cart-warning')?.classList?.add('mtt-modal--show')

        return
      }
    }

    document.querySelector('#cart-warning')?.classList?.remove('mtt-modal--show')

    if (accessoryIsArrayDiff(cartItems, storageCartItems, 'id')) {
      accessoryStorageSet('cart-items', cartItems)
    }
  }, [cartItems, setCartItems])

  useEffect(() => {
    setInteriorImage(null)
  }, [_currentStep])

  useEffect(() => {
    if (isStorageOrderHandled && !isAccessoryShop) {
      return
    }

    const _validSteps = validateSteps(currentVariant.steps ?? {}, order, isDealerConfigurator, currentVariant)
    const allSteps = currentVariant?.steps ? Object.keys(currentVariant.steps) : []
    const invalidSteps = allSteps.filter((stepID) => !_validSteps.map(String).includes(stepID))
    const minInvalidStep = Math.min(...invalidSteps.map(Number))
    const isValid = invalidSteps.length === 0 || _currentStep <= minInvalidStep

    if (!isValid) {
      setCurrentStep(1, true)
    }
  }, [_currentStep, setCurrentStep])

  useEffect(() => {
    if (isStorageOrderHandled && useStorage) {
      const strippedOrder = {
        ...order,
        configuration: {
          color: order.configuration.color.id,
          model_year: order.configuration.model_year.id,
          variants: order.configuration.variants.id,
          engine_transmission: order.configuration.engine_transmission.id,
          chargings: order?.configuration?.chargings ?? {},
          extra_equipments: order?.configuration?.extra_equipments ?? {},
          dealer_colors: order?.configuration?.dealer_colors ?? []
        }
      }

      storageSet(identifier, 'order', strippedOrder)
    }
  }, [order])

  useEffect(() => {
    if (isStorageOrderHandled && useStorage) {
      storageSet(identifier, 'currentModelYearId', currentModelYear.id)
    }
  }, [currentModelYear])

  useEffect(() => {
    if (isStorageOrderHandled && useStorage) {
      storageSet(identifier, 'currentVariantId', currentVariant.id)
    }
  }, [currentVariant])

  useEffect(() => {
    if (isStorageOrderHandled && useStorage) {
      storageSet(identifier, 'currentEngineTransmissionId', currentEngineTransmission.id)
    }
  }, [currentEngineTransmission])

  useEffect(() => {
    if (isStorageOrderHandled && useStorage) {
      storageSet(identifier, 'colorImageId', colorImage.id)
    }
  }, [colorImage])


  useEffect(() => {
    if (!isStorageOrderHandled) {
      return
    }

    if (Object.keys(locations).length <= 1) {
      setOrder({ ...order, pickup_location: Object.keys(locations)[0] })
    }

    defaultValidateSteps()

    const modalElement = window.jQuery('#cart-warning')
    modalElement
      .on('click', "[data-on-click='continue_shopping']", () => {
        modalElement.removeClass('mtt-modal--show')
        window.history.back()
      })
      .on('click', "[data-on-click='start_configurator']", () => {
        const newCartItems = [ ...cartItems ].filter((cartElement) => accessoryProductFitsCarByID(cartElement, car.id))
        accessoryStorageSet('cart-items', newCartItems)
      })

    const popstateListener = () => {
      const routeRegex = mgConfiguratorStep.route_regex
      const pathname = window.location.pathname
      const step = new RegExp(routeRegex).exec(pathname)?.[2]

      setCurrentStep(step ?? 1)
    }

    const storageListener = () => {
      setCartItems(accessoryStorageGet('cart-items') ?? [])
    }

    window.addEventListener('popstate', popstateListener, false)
    window.addEventListener('storage', storageListener, false)
    return () => {
      window.removeEventListener('popstate', popstateListener, false)
      window.removeEventListener('storage', storageListener, false)
    }
  }, [isStorageOrderHandled])

  return (
    <ConfiguratorContext.Provider value={{
      accessoriesShop,
      backLinkBesideLogoCallback: props.hasOwnProperty('back_link_beside_logo_callback') ? props.back_link_beside_logo_callback : null,
      car,
      cartItems,
      checkedChargings,
      checkedEquipmentRequirements,
      colorImage,
      colorName,
      colorSettingId,
      configurationLinkAvailable,
      configuratorUrl,
      currentDealerColorTotalCount,
      currentEngineTransmission,
      currentLeasingPriceRanges,
      currentModelYear,
      currentStep: _currentStep ? parseInt(_currentStep) : 1,
      currentVariant,
      dealerNumberOptions,
      dealerDebitorEmails,
      dealerDebitorNumbers,
      dealerPbvSpecificDebitorNumbers,
      dealerEmail,
      disabledEquipmentRequirements,
      embeddedConfiguratorToken: props.hasOwnProperty('embedded_configurator_token') ? props.embedded_configurator_token : null,
      endpoints,
      engineTransmissions,
      errors,
      hasConfiguration,
      hideSecurityDeposit,
      homeUrl,
      identifier,
      isAccessoryShop,
      isAccessoryShopOpen,
      isDealerConfigurator,
      isMenuOpen,
      isStorageOrderHandled,
      interiorImage,
      lang,
      locations,
      logo,
      modelYears,
      openConfigurationLink,
      order,
      orderType,
      paymentCardsImage,
      paymentTypes,
      restNonce,
      showGoWish,
      showPlateFieldAccessoryIds,
      strings,
      useSelectForDealers,
      validSteps,
      variants,
      vehicleType,
      zipCodes,
      showModelYearOnVariants: showModelYearOnVariants(),
      useStorage,

      isGlobalDownPaymentCash,
      isGlobalDownPaymentLeasing,
      globalDownPaymentCash,
      globalDownPaymentLeasing,
      showGlobalDownPaymentReservationText,

      defaultValidateSteps,
      setCar,
      setCartItems,
      setCheckedChargings,
      setCheckedEquipmentRequirements,
      setColorImage,
      setColorName,
      setColorSettingId,
      setCurrentDealerColorTotalCount,
      setCurrentEngineTransmission,
      setCurrentLeasingPriceRanges,
      setCurrentModelYear,
      setCurrentStep,
      setCurrentVariant,
      setDisabledEquipmentRequirements,
      setErrors,
      setInteriorImage,
      setIsAccessoryShopOpen,
      setIsMenuOpen,
      setIsStorageOrderHandled,
      setOpenConfigurationLink,
      setOrder: (newOrder) => {
        if (hideSecurityDeposit) {
          newOrder.security_deposit = 0
        }

        setOrder(newOrder)
      },
      setValidSteps,
      usePrice: () => getCurrentPrice(
        order.paymentType ?? 'cash',
        order,
        currentVariant,
        cartItems
      ),
      useSecurityDeposit: (useGlobalDownPayment = false) => {
        if (useGlobalDownPayment) {
          const paymentType = order.paymentType ?? 'cash'

          if (paymentType === 'cash' && isGlobalDownPaymentCash) {
            return globalDownPaymentCash
          }

          if (paymentType === 'leasing' && isGlobalDownPaymentLeasing) {
            return globalDownPaymentLeasing
          }
        }

        return getSecurityDeposit(
          order.paymentType ?? 'cash',
          order,
          currentVariant,
          currentEngineTransmission,
          cartItems
        )
      },
    }}>
      <>
        {isAccessoryShop ? null : <StorageLoad cartItems={cartItems} />}
        {
          // Don't render the children if the storage order is not handled
          isAccessoryShop || isStorageOrderHandled
            ? <>{props.children}</>
            : null
        }
      </>
    </ConfiguratorContext.Provider>
  )
}

export { ConfiguratorContext }
